/* eslint-disable no-unused-vars */
import {
  KINDLE_CLIENT,
  CPS_CLIENT,
  PSE_CLIENT,
  DOM_CLIENT,
  WEE_CLIENT,
  SRP_CLIENT,
  APS_CLIENT,
  NRG_CLIENT,
  CLECO,
  LANYARD_CLIENT,
  GENON_CLIENT,
} from '../client'

import {
  OaTmpMaDisplayExportHeaders,
  OaEventIoHeadersCPS,
  OaTmpMaTotalsHeaders,
  OaTmpMaTotalsHeadersDOM,
  OaTmpMaTotalsHeadersWEE,
  OaTmpMaTotalsHeadersCPS,
  SRPOaTmpMaDisplayExportHeaders,
  OaTmpMaTotalsHeadersAPS,
  OaTmpMaTotalsHeadersNRG,
  OaTmpMaTotalsHeadersCLECO,
  OaTmpMaTotalsHeadersPSE,
  OaTmpMaDisplayNrgTrueupExportHeaders,
  PSEOaTmpMaDisplayExportHeaders,
} from './Headers'

export const getEventTotalsHeader = CLIENT => {
  switch (CLIENT) {
    case WEE_CLIENT:
      return OaTmpMaTotalsHeadersWEE
    case DOM_CLIENT:
      return OaTmpMaTotalsHeadersDOM
    case CPS_CLIENT:
      return OaTmpMaTotalsHeadersCPS
    case APS_CLIENT:
      return OaTmpMaTotalsHeadersAPS
    case NRG_CLIENT:
    case LANYARD_CLIENT:
    case GENON_CLIENT:
      return OaTmpMaTotalsHeadersNRG
    case CLECO:
      return OaTmpMaTotalsHeadersCLECO
    case PSE_CLIENT:
      return OaTmpMaTotalsHeadersPSE
    default:
      return OaTmpMaTotalsHeaders
  }
}

export const getEventDataHeaders = CLIENT => {
  switch (CLIENT) {
    case CPS_CLIENT:
      return OaEventIoHeadersCPS
    default:
      return OaEventIoHeadersCPS
  }
}

export const getExportDataHeaders = (CLIENT, trueup) => {
  if (CLIENT === NRG_CLIENT && trueup)
    return OaTmpMaDisplayNrgTrueupExportHeaders
  switch (CLIENT) {
    case SRP_CLIENT:
    case APS_CLIENT:
      return SRPOaTmpMaDisplayExportHeaders
    case PSE_CLIENT:
      return PSEOaTmpMaDisplayExportHeaders
    case CPS_CLIENT:
      return OaTmpMaDisplayExportHeaders
    default:
      return OaTmpMaDisplayExportHeaders
  }
}
